import { ref, watch } from 'vue'

export default function useSwiper(unit:number, maxIndex:number) {
    const translateX = ref<string>('0%')
    const currentIndex = ref<number>(0)
    const startX = ref<number>(0)
    const isTouch = ref<boolean>(false)

    const onTouchStart = (e:any) => {
        startX.value = e.touches[0].clientX;
        isTouch.value = true
    }

    const onTouchMove = (e:any) => {
        const modify = 10
        if(isTouch.value) {
          isTouch.value = false
          const endX = e.touches[0].clientX;
          const distanceX = endX - startX.value;
      
          if(distanceX - modify > 0) {
            currentIndex.value === 0 || (currentIndex.value -= 1)
          }else if(distanceX + modify < 0){
            currentIndex.value === maxIndex || (currentIndex.value += 1)
          }
        }
      }

    const onTouchEnd = () => {
      isTouch.value = false
    }

    watch(() => currentIndex.value, () => translateX.value = `${-unit * currentIndex.value}%`)

    return { translateX, currentIndex, onTouchStart, onTouchMove, onTouchEnd }
}